<template>
  <el-dialog
    title="驳回"
    :visible.sync="dialogVisible"
    width="40%"
    class="addChannelAccountDialog"
    @close="dialogCloseHandle"
  >
    <el-form class="common_form" label-position="left" ref="rejectDialogFrom" :rules="rules" label-width="120px" :model="formData">
      <el-row>
        <el-col :span="24">
          <el-form-item label="驳回原因" prop="rejectReason">
            <el-input type="textarea" :rows="2" v-model="formData.rejectReason" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button plain @click="dialogCloseHandle">取消</el-button>
      <el-button type="primary" @click="submitHandler">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      dialogVisible: false,
      formData: {},
      rules: {
        rejectReason: [
          { required: true, message: '请输入驳回原因', trigger: 'blur' }
        ]
      }
    };
  },
  props: {
    rejectDialogShow: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    rejectDialogShow (val) {
      if (!val) {
        this.formData = {};
        this.$nextTick(() => {
          this.$refs.rejectDialogFrom.clearValidate();
        });
      }
      this.dialogVisible = val;
    }
  },
  methods: {
    dialogCloseHandle () {
      this.$emit('dialogCloseHandle');
    },
    submitHandler () {
      this.$refs['rejectDialogFrom'].validate((valid) => {
        if (valid) {
          this.$emit('submitHandler', this.formData);
        }
      });
    }
  }
};
</script>

<style scoped>

</style>
